<template>
  <div class="content-430">
    <SchoolSearch ref="schoolRef" @on-search="handleSearch"></SchoolSearch>

    <div class="count-main">
      <div class="title">
        <div>
          <h3>学校考勤确认单</h3>
        </div>
        <div>
          <Button
            v-if="portOrg != 2"
            type="primary"
            @click="handleNewSchoolAttend"
          >新增学校考勤确认单</Button>
          <Button
            v-if="portOrg != 2"
            type="primary"
            class="search-430"
            @click="handleTeacherList"
          >教师考勤结算流程</Button>
          <Button
            type="primary"
            class="search-430"
            @click="handleExport"
          >下载</Button>
        </div>
      </div>

      <ul class="count-num">
        <div v-if="showloading" class="demo-spin-container">
          <Spin fix></Spin>
        </div>
        <li>
          <Tooltip placement="top" class="tips">
            <template #content>
              <p>累计收入：统计学校该学期</p>
              <p>下累计的收入之和（不含退款)</p>
            </template>
            <Icon type="ios-alert-outline" size="20"></Icon>
          </Tooltip>
          <span class="font-bold" style="color: #2db7f5">{{
            countNumShow.totalRevenue
          }}</span>
          <p>累计收入</p>
        </li>
        <li>
          <Tooltip placement="top" class="tips">
            <template #content>
              <p>累计收入：统计学校该学期</p>
              <p>下已结算收入之和（包含支出部分）</p>
            </template>
            <Icon type="ios-alert-outline" size="20"></Icon>
          </Tooltip>
          <span class="font-bold" style="color: #63a103">{{
            countNumShow.settledRevenue
          }}</span>
          <p>已结算收入</p>
        </li>
        <li>
          <Tooltip placement="top" class="tips">
            <template #content>
              <p>待结算收入：统计学校该学期</p>
              <p>下待结算的金额部分</p>
            </template>
            <Icon type="ios-alert-outline" size="20"></Icon>
          </Tooltip>
          <span class="font-bold">{{ countNumShow.toBeSettledRevenue }}</span>
          <p>待结算收入</p>
        </li>
        <li>
          <Tooltip placement="top" class="tips">
            <template #content>
              <p>结算中收入：统计学校该学期</p>
              <p>结算中的金额部分</p>
            </template>
            <Icon type="ios-alert-outline" size="20"></Icon>
          </Tooltip>
          <span class="font-bold">{{ countNumShow.inSettlementRevenue }}</span>
          <p>结算中金额</p>
        </li>
        <li>
          <Tooltip placement="top" class="tips">
            <template #content>
              <p>费用支出：统计学校该学期下</p>
              <p>已结算金额的所有支出统计</p>
              <p>（含工资或其他类型支出)</p>
            </template>
            <Icon type="ios-alert-outline" size="20"></Icon>
          </Tooltip>
          <span class="font-bold" style="color: #d9001b">{{
            countNumShow.spending
          }}</span>
          <p>
            费用支出
            <span
              v-if="detailsEntryShow"
              class="cursor-pointer"
              style="color: #488ffa; margin-left: 6px"
              @click="handleToPayList"
            >
              <Icon
                type="ios-arrow-forward"
                style="position: relative; top: -1px"
              ></Icon>明细
            </span>
          </p>
        </li>
        <li>
          <Tooltip placement="top" class="tips">
            <template #content>
              <p>可用余额：统计学</p>
              <p>校下可用余额的</p>
              <p>总额（不区分学期）</p>
            </template>
            <Icon type="ios-alert-outline" size="20"></Icon>
          </Tooltip>
          <span class="font-bold">{{ countNumShow.availAmt }}</span>
          <p>可用余额</p>
        </li>
      </ul>
    </div>

    <div class="table-wrap">
      <Table
        :columns="schoolcolumns"
        :loading="loading"
        :data="tableList"
        border
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>

        <template slot="beginDate" slot-scope="{ row }">
          {{ row.beginDate | initBeginDateStr }}
        </template>

        <template slot="sheetSts" slot-scope="{ row }">
          {{ row.sheetSts | initSheetStr }}
        </template>
        <template slot="settleSts" slot-scope="{ row }">
          {{ row.settleSts | initSettleSts }}
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <span
            class="ordinary-color-430"
            style="margin-right: 8px"
            @click="handleToDetail(row)"
          >查看详情</span>
          <span
            v-if="row.sheetSts === 0 && portOrg != 2"
            class="del-btn-430"
            @click="handleDelect(row)"
          >删除</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :current="pageInfo.pageNum"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-total
        show-elevator
        show-sizer
        :page-size-opts="pageSizeOpts"
        @on-change="pageChange"
        @on-page-size-change="handleSizeChange"
      ></Page>
    </div>
  </div>
</template>

<script>
import SchoolSearch from './assets/components/SchoolSearch.vue';
import { schoolcolumns } from './assets/data/index';
import financeCenterApi from '@/request/financeCenter/index.js';
import { downloadReport, abs } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'AttendSettlementSchList',
  components: {
    SchoolSearch
  },

  filters: {
    initBeginDateStr(beginDate) {
      const day = beginDate.split('-');
      return `${day[0]}-${day[1]}`;
    },
    initSheetStr(sheetStr) {
      const map = {
        0: '待运营确认',
        1: '已对账',
        2: '待学校确认',
        3: '待财务确认',
        4: '财务驳回'
      };
      return map[sheetStr];
    },

    initSettleSts(sheetStr) {
      const map = {
        0: '待结算',
        1: '已结算',
        2: '结算中',
        3: '待结算'

      };
      return map[sheetStr];
    }
  },
  data() {
    return {
      schoolcolumns,
      showloading: false,
      tableList: [

      ],
      pageSizeOpts: [10, 20, 50, 100],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchConds: {},
      loading: false,
      portOrg: localStorage.getItem('portOrg'),
      countNum: {
        totalRevenue: 0.00,
        settledRevenue: 0.00,
        toBeSettledRevenue: 0.00,
        spending: 0.00
      }
    };
  },
  computed: {
    ...mapState(['adminIdentity', 'adminIdentityIndex']),
    ...mapGetters(['theUserIdentity']),
    // 学校端或者非宏途运营端不展示数据
    countNumShow() {
      // if ((this.adminIdentity[+this.adminIdentityIndex].orgType === 7)) {
      //   return {
      //     totalRevenue: '**',
      //     settledRevenue: '**',
      //     toBeSettledRevenue: '**',
      //     spending: '**'
      //   };
      // } else {
      return this.countNum;
      // }
    },
    detailsEntryShow() {
      if ((this.adminIdentity[+this.adminIdentityIndex].orgType === 7)) {
        return false;
      } else {
        return true;
      }
    }
  },
  created() {
    // this.portOrg = Number(localStorage.getItem('portOrg')); // 2 学校端

  },
  activated() {
    this.getSchoolSignConfirmList();
    this.getSchoolIncomeStatistics();
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('AttendSettlementSchList');
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    handleDelect(item) {
      this.$Modal.confirm({
        title: `是否确认删除ID:${item.sheetId}确认单？`,
        onOk: () => {
          this.deletetAttendItem(item.sheetId);
        },
        onCancel: () => { }
      });
    },
    deletetAttendItem(sheetId) {
      const params = { sheetId };
      financeCenterApi.deletePayrollApi(params).then(res => {
        if (res.status == 200) {
          this.$Message.success('删除成功');
          this.pageInfo.pageNum = 1;
          this.getSchoolSignConfirmList();
          this.getSchoolIncomeStatistics();
        } else {
          this.$Message.error('删除失败');
        }
      }).catch(err => {
        this.$Message.error('删除失败');
      });
    },
    handleNewSchoolAttend() {
      this.$router.push({
        name: 'financeCenter_attendSettlement_list_add'
      });
    },
    // 学校学期收入统计
    async getSchoolIncomeStatistics() {
      const { schoolId, yearCode, termCode } = this.searchConds;
      if (!yearCode || !termCode) {
        return null;
      }
      this.showloading = true;
      const res = await financeCenterApi.getSchoolIncomeStatisticsApi({
        schoolId,
        yearCode,
        termCode
      });
      if (res.status == 200) {
        for (const k in res.message) {
          this.countNum[k] = res.message[k] !== null ? abs(res.message[k]) : '0.00';
        }
      }
      this.showloading = false;
    },
    handleToPayList() {
      console.log('this.$refs.schoolRef.getSchoolName()', this.$refs.schoolRef.getSchoolName());
      const query = {
        schoolname: this.$refs.schoolRef.getSchoolName()
      };
      this.$router.push({ name: 'financeCenter_attendSettlement_payList', query });
    },
    async getSchoolSignConfirmList() {
      const parameter = {
        ...this.searchConds,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      let res = null;

      res = await financeCenterApi.getSchoolSignConfirmListApi(parameter);
      this.loading = false;
      if (res.status == 200) {
        res.message.list.forEach(item => {
          item.totalAmt = abs(item.totalAmt);
          item.realAmt = abs(item.realAmt);
        });
        this.tableList = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },

    handleExport() {
      const params = Object.assign({}, this.searchConds);
      for (const k in params) {
        if (params[k] === '') {
          delete params[k];
        }
      }
      let url;
      if (this.portOrg == 0) {
        url = `${process.env.VUE_APP_API_ORDER_URL}/admin/settlementSheetSch/exportSchoolSignConfirmList`;
      } else if (this.portOrg == 2) {
        url = `${process.env.VUE_APP_API_ORDER_URL}/school/settlementSheetSch/exportSchoolSignConfirmList`;
      }

      downloadReport(url, params, this);
    },

    // 筛选
    handleSearch(info) {
      this.pageInfo.pageNum = 1;
      this.searchConds = info;
      this.getSchoolSignConfirmList();
      this.getSchoolIncomeStatistics();
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
      this.getSchoolSignConfirmList();
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getSchoolSignConfirmList();
    },
    // 查看详情
    handleToDetail(row) {
      this.$router.push({
        name: 'financeCenter_attendSettlement_attendDetailed',
        query: {
          sheetId: row.sheetId,
          schoolName: row.schoolName,
          beginDate: row.beginDate,
          schoolId: row.schoolId,
          yearTerm: row.yearTerm
        }
      });
    },
    // 流程
    handleTeacherList() {
      this.$router.push({
        name: 'financeCenter_attendSettlement_process'
      });
    }

  }
};
</script>

<style lang="scss" scoped>
.count-main {
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 18px;
  width: 100%;
  margin: 12px 0;

  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    h3 {
      display: inline-block;
      margin-right: 32px;
    }
  }

  .count-num {
    display: flex;
    justify-content: space-between;
    position: relative;

    li {
      width: 180px;
      height: 80px;
      text-align: center;
      box-sizing: border-box;
      padding-top: 16px;
      border-radius: 10px;
      background: #eff0f8;
      margin-right: 16px;
      position: relative;

      p {
        padding-top: 10px;
      }

      .tips {
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
  }
}
</style>
